document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded and parsed.");
    
    // Step 1: Select the parent container that holds the elements
    const bannerContainer = document.querySelector(".tp-banner-container_custom");
    console.log("Step 1: Selected banner container:", bannerContainer);

    if (bannerContainer) {
        // Step 2: Create a new wrapper div
        const wrapperDiv = document.createElement("div");
        wrapperDiv.className = "tp_navigation_wrapper_custom";
        console.log("Step 2: Created new wrapper div:", wrapperDiv);

        // Step 3: Select the three specific elements to be wrapped
        const bullets = bannerContainer.querySelector(".tp-bullets");
        const leftArrow = bannerContainer.querySelector(".tp-leftarrow");
        const rightArrow = bannerContainer.querySelector(".tp-rightarrow");

        console.log("Step 3: Selected bullets:", bullets);
        console.log("Step 3: Selected left arrow:", leftArrow);
        console.log("Step 3: Selected right arrow:", rightArrow);

        if (bullets && leftArrow && rightArrow) {
            // Step 4: Append the elements to the new wrapper div
            wrapperDiv.appendChild(bullets);
            console.log("Step 4: Appended bullets to wrapper.");

            wrapperDiv.appendChild(leftArrow);
            console.log("Step 4: Appended left arrow to wrapper.");

            wrapperDiv.appendChild(rightArrow);
            console.log("Step 4: Appended right arrow to wrapper.");

            // Step 5: Append the new wrapper back to the banner container
            bannerContainer.appendChild(wrapperDiv);
            console.log("Step 5: Appended wrapper div back to banner container.");
        } else {
            console.error("Step 3: One or more navigation elements not found inside .tp-banner-container_custom");
        }
    } else {
        console.error("Step 1: .tp-banner-container_custom element not found");
    }
});
